import React from 'react';
import './Advantagespla.css';
import advantpl from '../../../imgs/advantplast.webp';

const Advantagespla = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">What Are The Advantages of Plastic Pallets?</h2>
                <p className="Material-date">Dec. 21, 2022</p>
                <div className="advantpl">
                    <img src={advantpl} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                <p className="Material-text">The wide application and development of plastic 
                    pallets is the general trend of the future transportation and warehousing industry, and it is also 
                    the need for plastic instead of wood environmental protection.</p>
            </div>
        </div>
    );
};
export default Advantagespla;
